var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0859 0V14.1406H15.1562V0H18.0859Z",
    fill: "#0AB2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 14.1406H0L4.90234 0H8.67188L13.5547 14.1406H10.4102L9.35547 10.8789H4.23828L3.16406 14.1406ZM4.98047 8.59375H8.61328L6.83594 3.18359H6.73828L4.98047 8.59375Z",
    fill: "#0AB2E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiText);
export default __webpack_public_path__ + "static/media/Icon_AI_Text.239dca5bad19378bac706c6682252bb0.svg";
export { ForwardRef as ReactComponent };